import React, { Component } from "react";
import ScreenHeader from "../labels/ScreenHeader";
import { TabStrip } from "../TabStrip";
import TicketListing from "./TicketListing";
import OutOfService from "./OutOfService";

const tabs = [
	{ display: "All Tickets", component: <TicketListing /> },
	{ display: "Recommendation", component: <TicketListing Recommendations={true} /> },
	{ display: "Sales Ticket", component: <TicketListing TicketType="9D13704F-808B-4267-A35F-245C7CB26D8D" SaleTicket={true} /> },
	{ display: "Out of Service", component: <OutOfService></OutOfService> },
];

export class TicketingPortal extends Component {
	render() {
		var pathName = document.location.pathname;
		var selected = 0;
		if (pathName.includes("recommendation")) {
			selected = 1;
		} else if (pathName.includes("salesticket")) {
			selected = 2;
		} else if (pathName.includes("outofservice")) {
			selected = 3;
		}
		return (
			<div style={{ display: "flex", flex: "1 0 100%", flexDirection: "column" }}>
				<div>
					<ScreenHeader title="All Tickets"></ScreenHeader>
				</div>
				<div style={{ display: "flex", flexDirection: "column", flex: 1, overflowY: "hidden" }}>
					<TabStrip tabs={tabs} selected={selected}></TabStrip>
				</div>
			</div>
		);
	}
}
